import { SignalRNotificationKey } from '../../signal-r-provider/SignalRNotificationKey'
import { SignalRMessageProps } from '../../signal-r-provider/signal-r-provider'

export const getDefaultMailBoxesValue = (): Record<SignalRNotificationKey, SignalRMessageProps[]> => {
    return {
        [SignalRNotificationKey.None]: [],
        [SignalRNotificationKey.TerminateContractsByTemplate]: [],
        [SignalRNotificationKey.TerminateContractsByTemplateError]: [],
        [SignalRNotificationKey.FileUploaded]: [],
        [SignalRNotificationKey.ResendActivationSuccess]: [],
        [SignalRNotificationKey.ResendActivationFailed]: [],
        [SignalRNotificationKey.FileDeleted]: [],
        [SignalRNotificationKey.ManualCutOffSuccess]: [],
        [SignalRNotificationKey.ManualCutOffFailed]: [],
        [SignalRNotificationKey.CutOffStarted]: [],
        [SignalRNotificationKey.CutOffCompleted]: [],
        [SignalRNotificationKey.CreateOrderSucceeded]: [],
        [SignalRNotificationKey.CreateOrderFailed]: [],
        [SignalRNotificationKey.ServicePointDeactivationErrorOpenOrders]: [],
        [SignalRNotificationKey.AssignContractToCompanyFailed]: [],
        [SignalRNotificationKey.PricingAgreementsAddedFromFile]: [],
        [SignalRNotificationKey.ImportStatement]: [],
        [SignalRNotificationKey.ResolvingAfasErrorsFinished]: [],
        [SignalRNotificationKey.ReimbursementsGenerated]: [],
        [SignalRNotificationKey.ImportStatementError]: [],
        [SignalRNotificationKey.EpacAdvancesImported]: [],
        [SignalRNotificationKey.StatementInvoiceCreated]: [],
        [SignalRNotificationKey.ImportDistributorsSuccess]: [],
        [SignalRNotificationKey.ImportDistributorsFailed]: [],
        [SignalRNotificationKey.ImportAdministrativeOrdersSuccess]: [],
        [SignalRNotificationKey.ImportAdministrativeOrdersFailed]: [],
        [SignalRNotificationKey.ActiveCompanyChanged]: [],
    }
}
